export default __webpack_public_path__ + "static/media/acropass-bug-patch-temporary.a33a31eb.png";